export enum PlatformSource {
  web = 1,
  android,
  ios,
  pc,
}

/**
 * 空数据
 */
export enum EmptyEnum {
  /**
   * 常规空数据
   */
  normal,
  /**
   * 搜索空数据
   */
  search,
}

/**
 * 直播状态
 */
export enum LiveStatusEnum {
  /**
   * 未开始
   */
  unStart,
  /**
   * 直播中
   */
  living,
  /**
   * 已结束
   */
  end,
}

/**
 * 内容类型
 */
export enum LmsContentTypeEnum {
  /**
   * 视频
   */
  video = 2,
  /**
   * 直播
   */
  live = 3,
}

/**
 * 章节类型 0：章 1：节
 */
export enum ChapterTypeEnum {
  /**
   * 0章
   */
  chapter,
  /**
   * 1节
   */
  section,
}

/**
 * 资源类型 0：录播视频 1：直播
 */
export enum ResourceTypeEnum {
  /**
   * 0：录播视频
   */
  record,
  /**
   * 1：直播
   */
  live,
  /**
   * 2：回放
   */
  playback,
}

/**
 * 回放类型
 */
export enum PlayBackTypeEnum {
  /**
   * 无回放
   */
  none = 0,
  /**
   * 回放视频
   */
  playback,
  /**
   * 点播视频
   */
  video,
}

/**
 * 用户类型 0-学生 1-老师 2-助教
 */
export enum RoleTypeEnum {
  /**
   * 0-学生
   */
  student,
  /**
   * 1-老师
   */
  teacher,
  /**
   * 2-助教
   */
  assistant,
}

/**
 * 用户类型映射
 */
export const roleTypeMap = {
  [RoleTypeEnum.student]: '学生',
  [RoleTypeEnum.teacher]: '讲师',
  [RoleTypeEnum.assistant]: '助教',
};

/**
 * 学历层次
 */
export enum EducationLevelEnum {
  /**
   * 无文凭
   */
  no = 0,
  /**
   * 小学
   */
  primary = 1,
  /**
   * 初中
   */
  junior = 2,
  /**
   * 高中/中专
   */
  senior = 3,
  /**
   * 大专
   */
  juniorCollege = 4,
  /**
   * 本科
   */
  regularCollege = 5,
  /**
   * 硕士
   */
  master = 6,
  /**
   * 博士
   */
  doctor = 7,
}

/**
 * 学员来源
 */
export enum StudentSourceEnum {
  /**
   * 0自助注册
   */
  register,
  /**
   * 1后台导入
   */
  backendImport,
  /**
   * 2订单生成
   */
  orderGenerate,
}

/**
 * 学员类型
 */
export enum StudentTypeEnum {
  /**
   * 0正式学员
   */
  official,
  /**
   * 1游客
   */
  visitor,
}

/**
 * 启用禁用
 */
export enum EnableEnum {
  /**
   * 禁用
   */
  disable,
  /**
   * 启用
   */
  enable,
}
